import { useOrganization } from "@clerk/clerk-react";

export const useClerkOrgInfo = () => {
  const { memberships } = useOrganization({
    memberships: {
      pageSize: 1000,
      initialPage: 0,
      infinite: true,
      keepPreviousData: true,
    },
  });

  return memberships?.data?.map((m) => m.publicUserData) ?? [];
};
